module.exports = __webpack_public_path__ + "img/house_ev_on.e13cbd28.png";